module.exports = __webpack_public_path__ + "media/site/images/technologies/ruby-icon-1696a1ceed7caf2a13a13e6705fd17e6.svg";